/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Faq_Ai_QInputs */

const en_wc_faq_ai_q = /** @type {(inputs: Wc_Faq_Ai_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was WordCraft built with AI?`)
};

/**
* | output |
* | --- |
* | "Was WordCraft built with AI?" |
*
* @param {Wc_Faq_Ai_QInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_faq_ai_q = /** @type {((inputs?: Wc_Faq_Ai_QInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Faq_Ai_QInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_faq_ai_q(inputs)
});
export { wc_faq_ai_q as "wc.faq.ai.q" }